import { useEffect, useState } from "react";
import Text from "components/atoms/text";
import { ClosedStoreIcon } from "utils/iconList";
import { S3_URL } from "config/envConfig";
import {
  ALLOW_ALL_STORES_KEY,
  DATA_REFERENCE,
  STORE_LIST_KEY,
  STORE_WAYPOINTS_KEY,
} from "utils/Constants";

export default function ClosedView({ isCloseViwed, title, subtitle }) {
  const [offlineSrc, setOfflineSrc] = useState(null);
  const [loaded, setLoaded] = useState(false);

  const getLocationFromURL = () => {
    const host = window.location.hostname;

    if (host === "localhost") return "mer";

    const domain = host.split(".")[0];
    const pieces = domain.split("-");
    return pieces[pieces.length - 1];
  };

  const tryImage = (url) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.src = url;
      img.onload = () => resolve(url);
      img.onerror = reject;
    });

  const resolveOffline = async () => {
    const location = getLocationFromURL();
    const locationId = location.toUpperCase() + "LOCID";

    let waypointUrl = null;

    const imageName = isCloseViwed
      ? "closeView.png"
      : "offlineView.png";

    try {
      const data = JSON.parse(localStorage.getItem(DATA_REFERENCE)) || {};
      const allowAll = data?.[ALLOW_ALL_STORES_KEY] ?? true;
      const storeList = data?.[STORE_LIST_KEY] || [];
      const waypoints = data?.[STORE_WAYPOINTS_KEY] || {};

      if (!allowAll && storeList.length === 1) {
        const wp = waypoints[storeList[0]];
        if (wp?.waypointId) {
          waypointUrl = `${S3_URL}/${locationId}/kiosk/${wp.waypointId}/${imageName}`;
        }
      }
    } catch {
      waypointUrl = null;
    }

    const defaultUrl = `${S3_URL}/${locationId}/kiosk/${imageName}`;

    if (waypointUrl) {
      try {
        return await tryImage(waypointUrl);
      } catch {}
    }

    try {
      return await tryImage(defaultUrl);
    } catch {
      return null;
    }
  };

  useEffect(() => {
    resolveOffline().then((src) => {
      setOfflineSrc(src);
      setLoaded(true);
    });
  }, [isCloseViwed]);

  if (!loaded) return null;

  if (offlineSrc) {
    return <img src={offlineSrc} alt="Offline" />;
  }

  return (
    <div className="flex flex-col items-center justify-center gap-16 px-24">
      <ClosedStoreIcon className="text-accent" />
      <div className="flex flex-col gap-12">
        <div
          style={{
            fontSize: "88px",
            fontWeight: "700",
            lineHeight: "120%",
            letterSpacing: "0em",
            textAlign: "center",
          }}
        >
          <Text fontFamily="var(--font-secondary)">
            {title || "Shops are closed at the moment"}
          </Text>
        </div>
        <div
          style={{
            fontSize: "60px",
            fontWeight: "700",
            lineHeight: "100%",
            letterSpacing: "0em",
            textAlign: "center",
          }}
        >
          <Text>{subtitle || "We are back again in the morning"}</Text>
        </div>
      </div>
    </div>
  );
}
